import React from "react";
import { Box, Typography, Button, Container, Card } from "@mui/material";
import { useNavigate } from "react-router-dom"; 

const WelcomeSection = (props) => {
    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate("/contact"); 
    };

    return (
        <Box
            sx={{
                // backgroundColor: "#000",
                color: "white",
                padding: "2rem 0",
                textAlign: "center",
            }}
        >
            <Container>
                <Card sx={{ background: "transparent", border: "2px solid #a66bbe", borderRadius: "20px", padding: "30px 20px" }}>
                    <Typography
                        variant="h4"
                        sx={{ fontWeight: "bold", color: "#fff", marginBottom: "10px" }}
                    >
                        {props.title}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{ color: "#cfcfcf", fontSize: "16px", marginBottom: "20px", color: "white" }}
                    >
                        {props.subtitle}
                    </Typography>
                    <Button
                        variant="outlined"
                        sx={{
                            color: "#c29bef",
                            borderColor: "#c29bef",
                            padding: "10px 20px",
                            borderRadius: "30px",
                            fontWeight: "bold",
                            border: "3px solid",
                            ":hover": {
                                backgroundColor: "transparent",
                                borderColor: "#D26FD8",
                                color: "#D26FD8",
                            },
                        }}
                        onClick={handleButtonClick}
                    >
                        {props.buttonText}
                    </Button>
                </Card>
            </Container>
        </Box>
    );
};

export default WelcomeSection;